export enum EAppointmentStatus {
    Checked_In = 201,
    Confirmed = 202,
    Consulted = 203,
    Pending = 204,
    Paperwork_Process = 205,
    Cancelled = 206,
    Requested_Rescheduled = 207,
}

export enum AppointmentReminder {
    Fifteen = 15,
    Thirty = 30,
    Sixty = 60,
    OneTwenty = 120,
    ThirtySixHundred = 3600,
}

export const AppointmentTeleMode = 'Tele';
